// extracted by mini-css-extract-plugin
export default {"LogInHeader":"LogIn_LogInHeader__hCvqP","LogInFrom":"LogIn_LogInFrom__mYdl2","LogInPageSection":"LogIn_LogInPageSection__YQgtm"};